export interface Order {
  checkoutTime: string;
  location: string;
  orderNumber: number;
  orderId: number;
  cashier: string;
  paymentType: string;
  subtotal: number;
  tax: number;
  tender: number;
  change: number;
  total: number;
  timeSpent: number;
  serviceTime: number;
  flags: string[];
  discountAmount: number;
  items: OrderItem[];
}

export function ordersToCsvInput(
  orders: Order[]
): {
  data: any[][];
  columns: Array<{ label: string; type?: string }>;
} {
  const keys: Array<keyof Omit<Order, 'flags' | 'items'>> = [
    'orderId',
    'checkoutTime',
    'location',
    'orderNumber',
    'cashier',
    'paymentType',
    'subtotal',
    'tax',
    'tender',
    'change',
    'total',
  ];

  const columns = keys.map(key => ({ label: key }));

  const data = orders.map(order =>
    keys.map(key => order[key])
  );

  return { data, columns };
}

export function orderItems(
  orders: Order[]
): {
  data: any[][];
  columns: Array<{ label: string; type?: string }>;
} {
  const keys: Array<keyof Omit<Order, 'flags' | 'items'>> = [
    'checkoutTime',
    'location',
    'orderNumber',
    'orderId',
    'cashier',
    'paymentType',
    'subtotal',
    'tax',
    'tender',
    'change',
    'total',
  ];

  const columns = keys.map(key => ({ label: key }));

  const data = orders.map(order =>
    keys.map(key => order[key])
  );

  return { data, columns };
}

export function orderItemsToCsvInput(
  orders: Order[]
): {
  orderItemData: any[][];
  orderItemColumns: Array<{ label: string; type?: string }>;
} {
  const itemKeys: Array<keyof OrderItem> = [
    'orderId',
    'description',
    'price',
    'displayPrice',
    'grossSales',
    'itemGrossSales',
    'itemNetSales',
    'netSales',
  ];

  const orderItemColumns = itemKeys.map(key => ({ label: key }));

  // Flatten all order items into a single array
  const orderItemData = orders.flatMap(order =>
    order.items.map(item =>
      itemKeys.map(key => item[key])
    )
  );

  return { orderItemData, orderItemColumns };
}

export interface OrderItem {
  orderId: number;
  description: string;
  price: number;
  displayPrice: number;
  grossSales: number;
  itemGrossSales: number;
  itemNetSales: number;
  netSales: number;
}

export interface OrderResult {
  orders: Order[];
  orderItems: OrderItem[];
}
